module.exports = __webpack_public_path__ + "static/media/wrong-02.632dd2d5.png";